import Page from '../../classes/Page'
import { app } from '../../utils/store'
import each from 'lodash/each'

import Hero from '../../modules/Hero'
import Navlist from '../../modules/Navlist'
export default class Home extends Page{
    constructor(){
        super({
            id : 'home',
            element: '[data-app-page]',
            elements: { 
                hero : document.querySelectorAll('[data-carousel="hero"]'),
                navlist: 'section.navlist',
            }
        })
    }

    create() {
        super.create()

        if(this.elements.hero){ this.createHero() }
        if(this.elements.navlist){ this.createNavlist() }
    }

    createHero() {
        each(this.elements.hero, (entry) => { return new Hero({ element: entry }) })
    }

    createNavlist = () => {
        this.navlist = new Navlist({ element: this.elements.navlist })
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}